import React from "react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getRefundNoteOptions } from "../../services/Refunds";

const RefundSuccess = () => {
  const { state } = useLocation();
  const [problemOptions, setProblemOptions] = useState([]);

  function fetchRefundOptions() {
    getRefundNoteOptions().then((response) => {
      const groupedOptions = [...response.data];
      setProblemOptions(groupedOptions);
    });
  }

  useEffect(() => {
    fetchRefundOptions();
  }, []);

  if (!state) return <div className="p-4">Tidak ada data untuk ditampilkan.</div>;

  return (
    <div className="min-h-screen bg-[#2b478e] px-4 py-8 flex justify-center">
      <div className="w-full max-w-2xl bg-white rounded-md shadow-md p-6">
        <center>
          <h1 className="text-2xl font-semibold mb-1">🎉 Refund Berhasil Diajukan</h1>
        </center>
        <br />
        <p className="text-red-500 font-medium mb-4">Mohon screenshot halaman ini sebagai backup.</p>
        <div className="bg-white rounded shadow p-4 border space-y-2 text-sm sm:text-base">
          {Object.entries(state).map(([key, value]) => (
            <div key={key}>
              {key === "id_refund_notes" ? (
                <strong>Jenis Kendala: </strong>
              ) : (
                <strong className="capitalize">{key.replace(/([A-Z])/g, " $1")}:</strong>
              )}{" "}


              {(key === "buktiPembayaran" || key === "buktiKendala") && JSON.parse(value).length > 0 ? (
                <div className="flex flex-row space-x-2">
                  {JSON.parse(value).map((item, index) => (
                    <img src={item} alt="Bukti Pembayaran" key={`${item}_${index}`} className="w-20 h-auto mb-2" />
                  ))}
                </div>
              ) : (typeof value === "object" && key === 'booth') && value?.display_name ? (
                value.display_name
              ) : (typeof value === "object" && value?.name) ? (
                value.name
              ) : (key === "id_refund_notes") ? (
                problemOptions.flatMap(group => group.options).find(option => option.value === value)?.label || value
              ) : (
                value?.toString()
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RefundSuccess;
